module.exports = __webpack_public_path__ + "img/神经网络计算-上层.14eea10b.png";